const state= {
    Items:{
        data:[],
        total:0,
        pages: {
            page:1,
            totalPage : 1,
            limit:50,
            filter:{

            }
        },
    },
    Loadings:{
        list:false,
        general:false,
        item:false,
        status:false,
    },
    Item:{
        line_item : []
    },
    ItemsWO : [],
    appInvoiceList: []
};

const getters = {
    Items : (state) => state.Items,
    Loadings : (state) => state.Loadings,
    contractId : (state) => state.contractId,
    Item : (state) => state.Item,
    ItemsWO : (state) => state.ItemsWO,
    appInvoiceList: state => state.appInvoiceList
};

const actions = {
    async getAppInvoiceList({commit}, params) {
        return new Promise((resolve, reject) => {
            commit( 'setLoadings', {key:"list",val:true});
            global.axios.get(`api/ap-invoice`, {
                params: params
            })
            .then(response => {
                commit( 'setLoadings', {key:"list",val:false});
                commit('SET_APP_INVOICE_LIST', response.data.data);
                resolve(response.data.data);
            })
            .catch(error => reject(error));
        });
    },
    async createApInvoice({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/ap-invoice`, {
                method: "POST",
                data : params,
                headers: {
                  Accept: "application/json",
              },
          })
            .then(response => {
                commit( 'createApInvoice', response.data.data );
                resolve(response)
            })
            .catch(error => reject( error ));
        });
    },
    async getApInvoice({commit}, params){
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key:"list",val:true});
            global.axios(`api/ap-invoice/${params.id}`, {
                method: "GET",
                headers: {
                  Accept: "application/json",
              },
          })
            .then(response => {
                commit( 'setLoadings', {key:"list",val:false});
                commit( 'getApInvoice', response.data.data );
                resolve(response)
            })
            .catch(error => reject( error ));
        });
    },
    async updateApInvoice({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/ap-invoice/${params.id}`, {
                method: "PUT",
                data : params,
                headers: {
                  Accept: "application/json",
              },
          })
            .then(response => {
                commit( 'getApInvoice', response.data.data );
                resolve(response)
            })
            .catch(error => reject( error ));
        });
    },
    async updateApInvoiceLineItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/ap-invoice/line-items/${params.id}`, {
                method: "PUT",
                data : params,
                headers: {
                    Accept: "application/json",
                },
            })
              .then(response => {
                  resolve(response)
              })
              .catch(error => reject( error ));
        });
    },
    async getListWO({commit}, params){
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key:"list",val:true});
            global.axios(`api/ap-invoice/wo`, {
                method: "GET",
                params: {
                    filter : params.filter,
                    limit: params.limit || -1
                },
                headers: {
                  Accept: "application/json",
              },
          })
            .then(response => {
                response.data.data.selectedWorkOrder = params.selectWorkOrder
                commit( 'setLoadings', {key:"list",val:false});
                commit( 'getApInvoiceWO', response.data.data );
                resolve(response)
            })
            .catch(error => reject( error ));
        });
    },
    async deleteApInvoice({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/ap-invoice`, {
                method: "DELETE",
                data: {
                    ids : params
                },
                headers: {
                  Accept: "application/json",
              },
            })
            .then(response => {
                resolve(response)
            })
            .catch(error => reject( error ));
        });
    },

    /**
     *  Line Items
     * */
    async createApLineItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/ap-invoice/line-items`, {
                method: "POST",
                data : params,
                headers: {
                    Accept: "application/json",
                },
            })
                .then(response => {
                    resolve(response)
                })
                .catch(error => reject( error ));
        });
    },

    async getApLineItems({commit}, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/ap-invoice/line-items`, {
                params: params
            })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async deleteLineItems({commit}, ids, reloadTax = false) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/ap-invoice/line-items`, {
                data: {
                    ids: ids,
                    reloadTax: reloadTax
                }
            })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        })
    },
    async changeStatusLineItems({commit}, params) {
        return new Promise((resolve, reject) => {
            global.axios.put(`api/ap-invoice/status-line-items`, params)
            .then(response => {
                resolve(response);
            })
            .catch(error => reject(error));
        })
    },
};

const mutations = {
    SET_APP_INVOICE_LIST(state, payload) {
        state.appInvoiceList = payload;
    },
    setItems (state,data) {
        data.pages.totalPage = Math.ceil(data.total / data.pages.limit );
        state.Items.data = data.items;
        state.Items.total = data.total;
        state.Items.pages = data.pages;
    },
    createApInvoice(state, data) {
        state.Items.data = [...state.Items.data, data];
        state.Items.total ++;
        state.Item = data
    },
    getApInvoice(state, data) {
        state.Item = data
        state.Loadings.list = false;
    },
    getApInvoiceWO(state, data) {
        state.ItemsWO =  data.items.map(item=>{
            let net_amount_total  = 0;
            let billable_amount_total  = 0;
            let check = true
            item.get_order_line_item = item.get_order_line_item.map(lineItem=>{
                if(!data.selectedWorkOrder.includes(lineItem.id))
                check = false
                net_amount_total += parseFloat(lineItem.net_amount)
                billable_amount_total += parseFloat(lineItem.billable_amount)
                return lineItem
            })
            item.net_amount_total    =  Math.round( net_amount_total * 100 + Number.EPSILON ) / 100
            item.billable_amount_total = Math.round( billable_amount_total * 100 + Number.EPSILON ) / 100
            item.checkAll = check
            return item

        })
    },
    setLoadings (state,data) {
        state.Loadings[data.key] = data.val;
    }

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
